import React, { useEffect, useState } from "react";
import CourseCard from "./CourseCard";
import { fetchCourses } from "./../../api/courseApi";
import { fetchCategory } from "./../../api/categoryApi";
import Loading from "../common/Loading";
import ToastService from "../../services/ToastService";
import { RiSearchLine } from '@remixicon/react';

const AllCourse = () => {
  const [courses, setCourses] = useState([]);
  const [isLoading, setLoading] = useState(true);


  const [searchTerm, setSearchTerm] = useState('');
  const [showMoreCategories, setShowMoreCategories] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [categories, setCategories] = useState([]);



  // Initial categories to show (before clicking "more")
  const initialCategories = categories.slice(0, 20);
  // Additional categories to show after clicking "more"
  const moreCategories = categories.slice(20);

  const displayedCategories = showMoreCategories
    ? categories
    : initialCategories;

  const toggleCategory = (categoryId) => {
    setSelectedCategories(prev => {
      if (prev.includes(categoryId)) {
        return prev.filter(cat => cat !== categoryId);
      } else {
        return [...prev, categoryId];
      }
    });
  };



  const fetchData = async () => {
    try {
      const data = await fetchCourses();

      if (data) {
        setCourses(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }

    try {
      const data = await fetchCategory();

      if (data) {
        setCategories(data);
        setLoading(false);

      }
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };



  useEffect(() => {
    fetchData();
  }, []);
  const filteredCourses = courses.filter((course) => {
    const matchesSearch = course.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategories.length === 0 || // ⬅️ if no category is selected, always return true
      course.categories?.some(cat => selectedCategories.includes(cat));

    return matchesSearch && matchesCategory;
  });
  return (
    <>
      <div
        className="p-6 w-full max-w-7xl mx-auto shadow-lg"
      >
        <h2 className="text-3xl font-bold mb-6 text-white">Find course</h2>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mb-8">
          {/* Search input */}
          <div className="relative">
            <RiSearchLine className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <input
              type="text"
              placeholder="Course name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 py-6 pr-4 w-full border rounded-md bg-white/5 text-white placeholder-gray-300 focus:outline-none focus:ring-2 "
            />
          </div>

        </div>

        <div className="mb-4">
          <h3 className="text-2xl font-semibold text-white mb-4">Categories</h3>
        </div>

        <div className="flex flex-wrap gap-2">
          {displayedCategories && displayedCategories.map((category, index) => (
            <button
              key={index}
              onClick={() => toggleCategory(category.id)}
              className={`py-4 px-4 rounded-md transition-colors border backdrop-blur-sm ${selectedCategories.includes(category.id)
                ? "bg-purple-700/70 text-white border-purple-500"
                : "bg-white/10 text-white hover:bg-white/20 border-white/20"
                }`}
            >
              {category.name}
            </button>
          ))}

          {!showMoreCategories && moreCategories.length > 0 && (
            <button
              onClick={() => setShowMoreCategories(true)}
              className="py-4 px-4 bg-white/10 text-white rounded-md hover:bg-white/20 transition-colors border border-white/20 backdrop-blur-sm"
            >
              + {moreCategories.length} more
            </button>
          )}
        </div>
      </div>

      <section className="all-challenges js-all-challenges">
        <h2 className="page-title">All courses</h2>

        <div className="items">
          {isLoading ? (
            <Loading />
          ) : (
            filteredCourses &&
            filteredCourses.map((item, index) => {
              return <CourseCard key={index} row={index} item={item} />;
            })
          )}
        </div>
      </section>
    </>

  );
};

export default AllCourse;
